// transcripts-api.ts
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  Transcript,
  TranscriptDetail,
  TranscriptionSegment,
} from '../types/transcript-types';
import { baseQueryWithErrorHandling } from './baseQuery';

export const transcriptsApiClient = createApi({
  reducerPath: 'transcriptsApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['Transcripts', 'TranscriptDetail', 'TranscriptSegments'] as const,
  endpoints: (builder) => ({
    getTranscripts: builder.query<
      Transcript[],
      { matterId: string; conversationId?: string }
    >({
      query: ({ matterId, conversationId }) => {
        let url = `api/matters/${matterId}/transcripts/`;
        if (conversationId) {
          url = `api/matters/${matterId}/audio-conversations/${conversationId}/transcripts/`;
        }
        return url;
      },
      providesTags: (result, error, { matterId, conversationId }) => [
        { type: 'Transcripts', id: conversationId || matterId },
      ],
    }),

    getTranscriptDetail: builder.query<
      TranscriptDetail,
      { matterId: string; conversationId: string; transcriptId: string }
    >({
      query: ({ matterId, conversationId, transcriptId }) => ({
        url: `api/matters/${matterId}/audio-conversations/${conversationId}/transcripts/${transcriptId}/details/`,
        method: 'GET',
      }),
      providesTags: (
        result,
        error,
        { matterId, conversationId, transcriptId },
      ) => [
        {
          type: 'TranscriptDetail',
          id: `${matterId}-${conversationId}-${transcriptId}`,
        },
      ],
    }),

    getTranscriptSegments: builder.query<
      TranscriptionSegment[],
      { matterId: string; conversationId: string }
    >({
      query: ({ matterId, conversationId }) => ({
        url: `api/matters/${matterId}/audio-conversations/${conversationId}/transcripts/segments/`,
        method: 'GET',
      }),
      providesTags: (result, error, { matterId, conversationId }) => [
        { type: 'TranscriptSegments', id: `${matterId}-${conversationId}` },
      ],
    }),
  }),
});

export const {
  useGetTranscriptsQuery,
  useGetTranscriptDetailQuery,
  useGetTranscriptSegmentsQuery,
} = transcriptsApiClient;
